import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { getLocale } from "@gamedev-web/gamedev-sdk-core";

import { MetaTags, OnboardingPageContainer } from "../../components";
import { getImage, ImageType } from "../../helpers/imageHelper";
import { useStrings } from "../../localization/localizationHelpers";
import { HeroContent } from "./HeroContent/HeroContent";
import * as styles from "./LandingPage.module.css";
import { XboxDeveloperPrograms } from "./XboxDeveloperPrograms/XboxDeveloperPrograms";

const LandingPage = () => {
  const [metaTitle, metaDescription, metaKeywords] = useStrings(
    "landingMetaTitle",
    "landingMetaDescription",
    "landingMetaKeywords"
  );
  const search = useLocation().search;
  const searchParams = new URLSearchParams(search);

  useEffect(() => {
    if (searchParams.has("partner")) {
      localStorage.setItem("partner", searchParams.get("partner") ?? "");
    }
  });

  const locale = useSelector(getLocale);

  return (
    <>
      <MetaTags
        title={metaTitle}
        description={metaDescription}
        keywords={metaKeywords}
        canonicalUrl={`https://developer.microsoft.com/${locale}/games/publish`}
        imageUrl={getImage("idxboxlogo", ImageType.Png)}
      />

      <OnboardingPageContainer className={styles.container} pageType={undefined}>
        <HeroContent />
        <div className={styles.programs}>
          <XboxDeveloperPrograms />
        </div>
      </OnboardingPageContainer>
    </>
  );
};

export default LandingPage;
